import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'results', 'empty']
  static values = { url: String }

  search() {
    clearTimeout(this._debounce)
    this._debounce = setTimeout(() => this._fetch(), 300)
  }

  clear() {
    this.inputTarget.value = ''
    this.resultsTarget.innerHTML = ''
    this.resultsTarget.classList.add('hidden')
  }

  async _fetch() {
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.resultsTarget.innerHTML = ''
      this.resultsTarget.classList.add('hidden')
      return
    }

    const url = `${this.urlValue}?query=${encodeURIComponent(query)}`
    const response = await fetch(url, {
      headers: { 'Accept': 'application/json', 'X-CSRF-Token': this._csrfToken() }
    })
    const listings = await response.json()

    if (listings.length === 0) {
      this.resultsTarget.innerHTML = '<div class="px-4 py-3 text-sm text-gray-500">Nenhum imóvel encontrado</div>'
      this.resultsTarget.classList.remove('hidden')
      return
    }

    this.resultsTarget.innerHTML = listings.map(l => `
      <div class="px-4 py-3 hover:bg-gray-50 flex items-center justify-between border-b border-gray-100 last:border-0">
        <div class="min-w-0 flex-1">
          <p class="text-sm font-medium text-gray-900 truncate">${this._escape(l.title || 'Sem título')}</p>
          <p class="text-xs text-gray-500 truncate">${this._escape(l.crm_id || '')} — ${this._escape(l.address || '')}</p>
        </div>
        <form method="post" action="${this.urlValue.replace('/search_units', '/associate_unit')}" class="ml-3 flex-shrink-0">
          <input type="hidden" name="authenticity_token" value="${this._csrfToken()}">
          <input type="hidden" name="listing_id" value="${l.id}">
          <button type="submit" class="inline-flex items-center px-3 py-1.5 text-xs font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 transition-colors">
            Associar
          </button>
        </form>
      </div>
    `).join('')
    this.resultsTarget.classList.remove('hidden')
  }

  _csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }

  _escape(str) {
    const div = document.createElement('div')
    div.textContent = str
    return div.innerHTML
  }
}
